import { RouteComponentProps } from 'react-router';
import { CSSProperties } from 'react';

const appStyles = {
  toolbar: {
    width: '100vw',
    backgroundColor: '#5f7d8c',
    zIndex: 999,
  },
  container80: {
    marginTop: 20,
    width: '80%',
    margin: '0 auto',
  },
  container60: {
    marginTop: 20,
    width: '60%',
    margin: '0 auto',
  },
  contentColumn: {
    color: 'rgba(255, 255, 255, 0.87)',
  },
  input: {
    width: '100%',
    marginTop: 10,
    marginBottom: 10,
    color: '#FFF',
  },
  inputDark: {
    width: '100%',
    marginTop: 10,
    marginBottom: 10,
    color: 'rgba(255, 255, 255, 0.3)',
  },
  subHeader: {
    marginTop: 40,
  },
  helpText: {
    fontSize: 12,
  },
  col260: {
    width: 260,
  },
  loader: {
    color: '#e1f694',
  },
  chip100: {
    width: '100%',
    borderRadius: 2,
    border: '1px solid rgba(255, 255, 255, 0.12)',
    backgroundColor: 'transparent',
    paddingTop: 11,
    paddingBottom: 11,
  },
  btnDark100: {
    width: '100%',
    borderRadius: 2,
    border: '1px solid rgba(255, 255, 255, 0.3)',
  },
  leftDrawer: {
    background: '#36474f',
    color: 'white',
    width: 200,
    border: '0 !important',
  },
  leftDrawer400: {
    background: '#36474f',
    color: 'white',
    width: 400,
    border: '0 !important',
  },
  checkbox: {
    color: '#e1f694',
  },
  control_disabled: {
    opacity: 0.33,
  },
  button_primary: {
    backgroundColor: '#e1f694',
    color: '#253238',
  },
};

export function activeButtonStyle(selected: boolean): object {
  if (!selected) {
    return { marginRight: 5 };
  }
  return {
    border: '1px solid rgb(225, 246, 148)',
    marginRight: 5,
  };
}

export default appStyles;

export interface StyleProps extends RouteComponentProps<{}> {
  classes: {
    [key: string]: CSSProperties;
  };
}



// WEBPACK FOOTER //
// ./src/utils/style.ts